/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const FixedDepositPage = lazyLoad(
  () => import('./index'),
  module => module.FixedDepositPage,
);
